export default {
  set(state, { data }) {
    state.combos = data;
  },
  show(state, { data }) {
    state.combo = data;
  }
}